module.exports = __webpack_public_path__ + "media/images/forms-icons/phone-icon-hover-a8fcae26105f996c4e7f94ad821fc020.svg";